import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@limuzin/kit/tokens.css';
import '@limuzin/kit/components.css';
import './theme.css';
import { App } from './app';
import { startInsets } from './insets';
import { startTheme } from './theme';
import { startUpdates } from './update';

startTheme();
startInsets();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

/**
 * The service worker, registered only in a real build.
 *
 * In development it would sit between Vite and the page and serve yesterday's bundle
 * out of the cache, which is an afternoon nobody gets back. `import.meta.env.PROD` is
 * false under `vite dev` and true in `dist`.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // A private window, a browser with workers disabled, or plain http. The app
      // works without one; it just is not installable.
    });
  });
}

/** With a worker or without one, an open page learns of a new build by asking. */
if (import.meta.env.PROD) startUpdates();
